export default __webpack_public_path__ + "static/media/thumbnail.7f7b96c2.webp";